import { render, staticRenderFns } from "./Microsoft.vue?vue&type=template&id=d1552f00&scoped=true&"
import script from "./Microsoft.vue?vue&type=script&lang=ts&"
export * from "./Microsoft.vue?vue&type=script&lang=ts&"
import style0 from "./Microsoft.vue?vue&type=style&index=0&id=d1552f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1552f00",
  null
  
)

export default component.exports